<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="saleForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="sale" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                saleForm: () => import('../forms/SaleForm'),
                sale: () => import('../editViews/Sale'),
                headers: [
                    { text: 'Vendor Declaration Number', value: 'vendorDeclarationNumber' },
                    { text: 'Purchased On', value: 'purchasedOn', format: this.formatDate },
                    { text: 'Delivery On', value: 'deliveryOn', format: this.formatDate },
                    { text: 'Seller Member', value: 'sellerMemberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Seller Name', value: 'sellerName' },
                    { text: 'Buyer Member', value: 'buyerMemberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Buyer Name', value: 'buyerName' },
                    { text: 'Price', value: 'price' },
                    { text: 'Supervision Period In Months', value: 'supervisionPeriodInMonths' },
                    { text: 'Has Recent Afb Evidence', value: 'hasRecentAfbEvidence' },
                    { text: 'Has Recent Honey Culture Test', value: 'hasRecentHoneyCultureTest' },
                    { text: 'Has Antibiotic Treatment', value: 'hasAntibioticTreatment' },
                    { text: 'Has Toxic Substance Exposure', value: 'hasToxicSubstanceExposure' },
                    { text: 'Has Proximity To GMO', value: 'hasProximityToGmo' },
                    { text: 'Is Beekeeper Declaration Completed', value: 'isBeekeeperDeclarationCompleted' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "deliveryOn", direction: "descending" },
                    { column: "vendorDeclarationNumber", direction: "ascending" },
                    { column: "sellerMemberId", direction: "ascending" },
                ],
                itemsField: 'sales',
                editPageName: 'sale',
                apiMethod: 'Sales',
                claimName: 'Sales',
                formTitle: 'Sale',
                excelTitle: 'Sales',
                hasEditPage: true,
            }
        },
    };
</script>
